<script>
  import { isArray } from 'lodash'
  import estadosBr from '../../../../_default/utils/estados-brasileiros'
  import LoteEntidadeService from '../../../../../domain/leiloes/services/lote-entidade'
  import PopupViewer from '../../../../_default/components/popup-viewer/PopupViewer'
  import {VueMaskDirective as mask} from 'v-mask'

  export default {
    components: {
      PopupViewer,
      NovoTipoLoteEntidade: () => import('./NovoTipoLoteEntidade')
    },
    directives: {mask},
    nome: 'nova-entidade-lote',
    props: {
      entidadeId: {
        type: Number,
        required: false,
        default: null
      }
    },
    data () {
      return {
        isLoading: false,
        isLoaded: false,
        cadastroError: null,
        atualizadoSucesso: null,
        data: {
          id: null,
          nome: null,
          cep: null,
          endereco: null,
          numero: null,
          complemento: null,
          estado: null,
          cidade: null,
          bairro: null,
          tipoDocumento: 1,
          documento: null,
          banco: null,
          tipo: null
        },
        tiposDocumento: [
          {id: 1, nome: 'CPF'},
          {id: 2, nome: 'CNPJ'}
        ],
        tiposEntidade: [],
        showTipoEntidadeForm: false
      }
    },
    computed: {
      estadosBr () {
        return estadosBr
      }
    },
    created () {
      this.carregarTiposEntidade()
    },
    mounted () {
      this.start()
    },
    activated () {
    },
    destroyed () {
    },
    watch: {},
    methods: {
      start () {
        if (this.entidadeId) {
          this.$parent.loading(true)
          LoteEntidadeService.findEntidadeLote(this.entidadeId)
            .then((response) => {
              this.isLoaded = true
              this.data = response.data
              this.data.tipo = this.data.tipo.id
            })
            .catch((response) => {
              console.log(response)
            })
            .finally(() => {
              this.$parent.loading(false)
            })
        } else {
          this.isLoaded = true
          // this.$loaderOverlay.open().message('Aguarde')
        }
      },
      submit () {
        this.cadastroError = null
        this.atualizadoSucesso = false
        this.$bar.start()
        this.$parent.loading(true)
        LoteEntidadeService.cadastroEntidadeLote(this.data, this.$route.params.id, this.entidadeId)
          .then((response) => {
            let callbackEnd = () => {
              this.$bar.finish()
              if (this.$route.params.id) {
              // Continua na mesma tela de edição
              // this.$nextTick(() => {
                this.start()
                this.atualizadoSucesso = true
                this.$el.querySelector('#sucessMsg').focus()
              // })
              } else {
              // Redirecionr para tela de visualização
              // this.$router.push({name: 'documento.editar', params: {id: response.data.id}})
                this.atualizadoSucesso = true
              }
              this.$emit('finishSubmit')
            }
            callbackEnd()
          }).catch((response) => {
            this.$bar.finish()
            this.cadastroError = response.data.errors
            this.$nextTick(() => {
              this.$refs.error.focus()
            })
            console.log(response)
          })
          .finally(() => {
            this.$parent.loading(false)
          })
      },
      carregarTiposEntidade () {
        LoteEntidadeService.listAllTipoEntidade()
          .then(response => {
            this.tiposEntidade = response.data
          })
          .catch(error => {
            this.cadastroError = error.data.errors
          })
      },
      openTipoEntidadeForm () {
        this.showTipoEntidadeForm = true
      },
      closeTipoEntidadeForm () {
        this.showTipoEntidadeForm = false
      },
      finishSubmitCadastroTipoEntidade () {
        this.closeTipoEntidadeForm()
        this.carregarTiposEntidade()
      },
      printError (err) {
        if (isArray(err)) {
          return err[0]
        }
        return err
      }
    }
  }
</script>

<template>
  <transition name="slide">
    <div v-if="isLoaded" class="content-transition">
      <div class="bg-light lter b-b wrapper-md">
        <div class="row">
          <div class="col-sm-6"><h1 class="m-n font-thin h3">Gerenciamento de Entidade</h1></div>
        </div>
      </div>
      <div class="wrapper-md">
        <div class="panel panel-default">
          <div class="panel-body">
            <div tabindex="-1" ref="error" v-if="cadastroError !== null" class="alert alert-danger">
              <div class="m-b-sm font-bold">Erro ao registrar, corrija e tente novamente</div>
              <p v-for="(erro, key) in cadastroError">{{printError(erro)}}</p>
            </div>
            <a name="sucessMsg" id="sucessMsg" href="javascript:void(0)" ref="sucessMsg"></a>
            <div tabindex="-1" ref="error" v-if="atualizadoSucesso !== null && atualizadoSucesso" class="alert alert-success">
              <div class="font-bold">{{$route.params.id && 'Atualizado' || 'Cadastrado'}} com sucesso!</div>
            </div>
            <form @submit.prevent.stop="submit" class="bs-example form-horizontal">
<!--
              <div class="form-group">
                <label class="col-sm-4 control-label">Estado</label>
                <div class="col-sm-8">
                  <select class="form-control" v-model="data.banco" required>
                    <option :value="null" disabled>Selecione</option>
                    <option :value="estado.sigla" v-for="estado in bancos" :key="banco.id">{{banco.nome}}</option>
                  </select>
                </div>
              </div>-->

              <div class="form-group">
                <label class="col-sm-4 control-label">Nome</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="data.nome" required />
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-4 control-label">CEP</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="data.cep" required v-mask="'##.###-###'"/>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-4 control-label">Endereço</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="data.endereco" required/>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-4 control-label">Número</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="data.numero" required/>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-4 control-label">Complemento</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="data.complemento"/>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-4 control-label">Estado</label>
                <div class="col-sm-8">
                  <select class="form-control" v-model="data.estado" required>
                    <option :value="null" disabled>Selecione</option>
                    <option :value="estado.sigla" v-for="estado in estadosBr" :key="estado.sigla">{{estado.nome}}</option>
                  </select>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-4 control-label">Cidade</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="data.cidade" required/>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-4 control-label">Bairro</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="data.bairro" required/>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-4 control-label">Tipo de Documento</label>
                <div class="col-sm-8">
                  <select class="form-control" v-model="data.tipoDocumento" required>
                    <option :value="tipo.id" v-for="tipo in tiposDocumento" :key="tipo.id">{{tipo.nome}}</option>
                  </select>
                </div>
              </div>
              <div class="form-group">
                <label for="numeroDocumento" class="col-sm-4 control-label">Número documento</label>
                <div class="col-sm-8" v-if="data.tipoDocumento === 1">
                  <input autocomplete="off" required id="numeroDocumento" type="text"
                         v-model="data.documento"
                         v-mask="'###.###.###-##'"
                         class="form-control">
                </div>
                <div class="col-sm-8" v-else>
                  <input autocomplete="off" required id="numeroDocumento" type="text"
                         v-model="data.documento"
                         v-mask="'##.###.###/####-##'"
                         class="form-control">
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-4 control-label">Tipo</label>
                <div class="col-sm-8">
                  <select class="form-control" v-model="data.tipo" required>
                    <option :value="null" disabled>Selecione</option>
                    <option :value="tipo.id" v-for="tipo in tiposEntidade" :key="tipo.id">{{tipo.nome}}</option>
                  </select>
                  <u-button class="btn btn-xs pull-right m-t-sm m-b-xs m-r-xs btn-default" @click="openTipoEntidadeForm">
                    <i class="fa fa-plus"></i> Cadastrar tipo de entidade
                  </u-button>
                </div>
              </div>

              <div class="clearfix"></div>

              <hr>
              <div class="row wrapper">
                <u-button type="submit" class="btn m-b-xs w-xs btn-info m-r-xs">
                  <span v-if="!data.id">Cadastrar</span>
                  <span v-if="data.id">Atualizar</span>
                </u-button>
                <u-button class="btn m-b-xs w-xs m-r-xs btn-default" @click="$emit('cancel')">Cancelar</u-button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <popup-viewer @close="closeTipoEntidadeForm" v-if="showTipoEntidadeForm" :title="`Cadastro de Tipo de Entidade`">
        <NovoTipoLoteEntidade @cancel="closeTipoEntidadeForm" @finishSubmit="finishSubmitCadastroTipoEntidade" />
      </popup-viewer>
    </div>
  </transition>
</template>



// WEBPACK FOOTER //
// NovaEntidadeLote.vue?4c5e6fba